export type ClassificationType =
    | "skills"
    | "locations"
    | "independencyLevels"
    | "subjects"
    | "teacher_goals"
    | "teacher_abilities"
    | "classes"
    | "toolkit";

export type Classification = {
    id: number;
    name: string;
    description?: string;
    explanation?: string;
    icon: File | string | null;
    text_color?: string;
    background_color?: string;
    light_border_color?: string;
    strong_border_color?: string;
    type: ClassificationType;
    is_list: boolean;
};

export const getQueryKey = (classificationType: ClassificationType) => [
    "classifications",
    classificationType,
];

const listClassificationTitles = {
    classes: "כיתות",
};

export function isListClassification(classificationType: ClassificationType) {
    return listClassificationTitles.hasOwnProperty(classificationType);
}

export function getListClassificationTitle(
    classificationType: ClassificationType
) {
    return isListClassification(classificationType)
        ? listClassificationTitles[
              classificationType as keyof typeof listClassificationTitles
          ] || "פריטים"
        : undefined;
}

export function listClassificationItems(classifications: Classification[]) {
    return classifications
        .map((c) => (c.description || "").split(","))
        .flat()
        .map((s) => s.trim())
        .filter((s) => s !== "")
        .map((s, index) => ({
            id: index,
            name: s,
        })) as Classification[];
}
